<app-nav-bar></app-nav-bar>

<div class="max-w-[1360px] mx-auto px-5 md:py-7 lg:py-10">
    <!-- The column gap is only applied from lg up, where the two columns sit side by side.
         Below that they stack, and 11 gaps of 30px would force the grid to at least 330px
         wide - more than a small phone leaves after the container padding, which pushed the
         filter row out past the container. -->
    <div class="grid grid-cols-12 gap-y-[10px] gap-x-0 lg:gap-x-[10px] max-[576px]:pb-5">
        <div class="leaderboard-col col-span-12 lg:col-span-8">
            <div class="flex flex-col md:flex-row justify-between align-items-center pb-5 border-b border-secondary-button-black gap-4">
                <h1 class="text-[26px] text-black font-medium max-[767px]:pt-[20px]  max-[576px]:text-[20px]">Leaderboard</h1>
                <div class="flex flex-wrap items-center gap-5 max-[576px]:flex-nowrap max-[576px]:gap-3">
                    <!-- Time filter dropdown (575px and below only) -->
                    <div class="relative hidden max-[576px]:block max-[576px]:flex-1 max-[576px]:min-w-0">
                        <button #timeTrigger (click)="toggleTimeDropdown()"
                            class="w-full flex items-center justify-between gap-3 text-black text-base font-medium border border-secondary-button-black rounded-lg px-4 py-3 cursor-pointer max-[576px]:text-sm">
                            {{ activeTab }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="shrink-0 transition-transform duration-200"
                                [ngClass]="{ 'rotate-180': isTimeOpen }">
                                <path d="M11.7344 6.40042C11.7344 6.40042 8.78844 10.4004 7.73438 10.4004
                                C6.68024 10.4004 3.73438 6.40039 3.73438 6.40039" stroke="black" stroke-opacity="0.8"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <!-- Sized to the room left around the button so the list always ends
                             inside the screen, clear of the fixed mobile tab bar -->
                        <ul *ngIf="isTimeOpen" [style.maxHeight.px]="timeMenu.maxHeight"
                            [ngClass]="timeMenu.above ? 'bottom-full mb-1.5' : 'top-full mt-1.5'"
                            class="absolute z-20 w-full overflow-y-auto overscroll-contain border border-secondary-button-black rounded-lg bg-white shadow-lg">
                            <li *ngFor="let tab of tabs" (click)="selectTimeTab(tab)" class="text-base font-medium !leading-2.5 py-4 px-[18px]
                             border-b last:border-b-0 border-secondary-button-black
                             hover:bg-light-black-300 duration-200 ease-in-out cursor-pointer"
                                [ngClass]="activeTab === tab ? 'text-black' : 'text-secondary-text-black'">
                                {{ tab }}
                            </li>
                        </ul>
                    </div>

                    <ul class="flex items-center gap-3.5 max-[576px]:hidden">
                        <li *ngFor="let tab of tabs" (click)="setActiveTab(tab)"
                            class="cursor-pointer text-base !leading-3 font-normal pt-2.5 pb-2 px-3.5 rounded-full border transition-all"
                            [ngClass]="
                            activeTab === tab
                                ? 'text-black bg-secondary-button-black font-semibold border-black'
                                : 'text-secondary-text-black border-transparent hover:bg-secondary-button-black'
                            ">
                            {{ tab }}
                        </li>
                    </ul>
                    <div class="relative inline-block max-[576px]:block max-[576px]:flex-1 max-[576px]:min-w-0">
                        <button #categoryTrigger (click)="toggleDropdown()"
                            class="w-[190px] max-[576px]:w-full flex items-center justify-between gap-3 text-black text-base lg:text-lg font-medium border border-secondary-button-black rounded-lg px-4 py-3 cursor-pointer max-[576px]:text-sm">
                            <span class="truncate">{{ selectedCategory }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="shrink-0 transition-transform duration-200"
                                [ngClass]="{ 'rotate-180': isOpen }">
                                <path d="M11.7344 6.40042C11.7344 6.40042 8.78844 10.4004 7.73438 10.4004
                                C6.68024 10.4004 3.73438 6.40039 3.73438 6.40039" stroke="black" stroke-opacity="0.8"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <!-- The category list outgrows the viewport, so it scrolls inside itself;
                             overscroll-contain keeps a scroll that reaches either end from
                             carrying on into the page behind it. Its height is measured from the
                             space left below the button, so the last row stays reachable on every
                             screen instead of running under the viewport edge or the tab bar. -->
                        <ul *ngIf="isOpen" [style.maxHeight.px]="categoryMenu.maxHeight"
                            [ngClass]="categoryMenu.above ? 'bottom-full mb-1.5' : 'top-full mt-1.5'"
                            class="absolute z-10 w-[190px] max-[576px]:w-full overflow-y-auto overscroll-contain border border-secondary-button-black rounded-lg bg-white shadow-lg">
                            <li *ngFor="let category of categories" (click)="selectCategory(category)" class="text-base lg:text-lg font-medium !leading-2.5 py-4 px-[18px]
                             border-b last:border-b-0 border-secondary-button-black
                             hover:bg-light-black-300 duration-200 ease-in-out cursor-pointer">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="no-scrollbar max-[576px]:overflow-x-auto max-[576px]:overflow-y-hidden">
              <div class="max-[576px]:min-w-[400px]">
                <!-- Data Display -->
                <div
                    class="flex flex-row items-end justify-between pt-6 gap-4 border-b border-secondary-button-black">
                    <div
                        class="flex items-center gap-2.5 md:gap-3.5 flex-1 min-w-0 pb-3.5 -mb-px border-b-2 border-transparent">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                            class="w-5 h-5 md:w-6 md:h-6 shrink-0">
                            <path
                                d="M18.5 18.5L22 22M21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C16.7467 21 21 16.7467 21 11.5Z"
                                stroke="black" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                        <input type="text" placeholder="Search by name" [(ngModel)]="searchQuery"
                            (ngModelChange)="onSearchChange()"
                            class="text-base md:text-lg font-normal text-black w-full bg-transparent placeholder:text-secondary-text-black border-0 outline-none p-0" />
                    </div>
                    <div class="flex items-end gap-4 md:gap-[30px] shrink-0 max-[767px]:hidden">
                        <button (click)="setProfitTab('profit')"
                            class="text-base md:text-lg lg:text-xl font-medium pb-3.5 -mb-px cursor-pointer border-b-2 transition-all"
                            [ngClass]="activeProfitTab === 'profit' ? 'text-black border-primary-text-green' : 'text-secondary-text-black border-transparent'">
                            Profit/Loss
                        </button>
                        <span
                            class="text-base md:text-lg lg:text-xl inline-block text-secondary-button-black font-medium pb-3.5 -mb-px border-b-2 border-transparent">|</span>
                        <button (click)="setProfitTab('volume')"
                            class="text-base md:text-lg lg:text-xl font-medium pb-3.5 -mb-px cursor-pointer border-b-2 transition-all"
                            [ngClass]="activeProfitTab === 'volume' ? 'text-black border-primary-text-green' : 'text-secondary-text-black border-transparent'">
                            Volume
                        </button>
                    </div>

                    <!-- Profit/Volume dropdown (767px and below only) -->
                    <div class="relative hidden max-[767px]:block shrink-0">
                        <button (click)="toggleProfitDropdown()"
                            class="flex items-center gap-2 text-base font-medium text-black pb-3.5 -mb-px cursor-pointer border-b-2 border-primary-text-green">
                            {{ activeProfitLabel }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                                fill="none" class="shrink-0 transition-transform duration-200"
                                [ngClass]="{ 'rotate-180': isProfitOpen }">
                                <path d="M11.7344 6.40042C11.7344 6.40042 8.78844 10.4004 7.73438 10.4004
                                C6.68024 10.4004 3.73438 6.40039 3.73438 6.40039" stroke="black" stroke-opacity="0.8"
                                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                        <ul *ngIf="isProfitOpen"
                            class="absolute right-0 z-20 min-w-[140px] border border-secondary-button-black rounded-lg mt-1.5 bg-white shadow-lg">
                            <ng-container *ngFor="let tab of profitTabs">
                                <li *ngIf="tab.key !== activeProfitTab" (click)="selectProfitTab(tab.key)"
                                    class="text-base font-medium !leading-2.5 text-black py-4 px-[18px]
                                     border-b last:border-b-0 border-secondary-button-black
                                     hover:bg-light-black-300 duration-200 ease-in-out cursor-pointer whitespace-nowrap">
                                    {{ tab.label }}
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </div>

                <div *ngIf="!loading; else loader">
                    <div *ngFor="let item of leaderboardData; let i = index">
                        <div [routerLink]="['/leaderboard-details']"
                            [queryParams]="{ user_id: item.user_id || item.id }"
                            class="flex items-center justify-between p-4 cursor-pointer hover:bg-light-black-300 rounded-xl duration-200 ease-in-out">
                            <div class="flex items-center gap-4">
                                <span class="text-black text-lg font-medium min-w-[24px] max-[576px]:w-[18px]">{{ item.rank || i + 1
                                    }}</span>
                                <span
                                    class="flex items-center justify-center w-10 h-10 max-[576px]:w-8  max-[576px]:h-8  rounded-full bg-secondary-button-black text-black font-bold uppercase"
                                    *ngIf="!item.profile_picture">
                                    {{ item.username?.charAt(0) }}
                                </span>
                                <img [src]="item.profile_picture" *ngIf="item.profile_picture"
                                    class="w-10 h-10 rounded-full" />
                                <div class="relative group">
                                    <p class="text-lg max-[576px]:text-base font-medium !leading-3 text-black group-hover:underline">{{
                                        shortenUsername(item.username) }}</p>

                                    <!-- Hover Popover using Global Keys -->
                                    <div
                                        class="w-[296px] bg-white absolute top-full -left-16 z-50 mt-2 border border-secondary-button-black rounded-[15px] p-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 ease-in-out shadow-xl">
                                        <div class="flex items-center gap-4">
                                            <div class="flex items-center justify-center w-11 h-11 rounded-full bg-secondary-button-black text-black font-bold uppercase"
                                                *ngIf="!item.profile_picture">
                                                {{ item.username?.charAt(0) }}
                                            </div>
                                            <img [src]="item.profile_picture" *ngIf="item.profile_picture" alt="profile"
                                                class="w-11 h-11 rounded-full">
                                            <div class="flex flex-col">
                                                <h4 class="text-base text-black font-medium">{{
                                                    shortenUsername(item.username) }}</h4>
                                                <p class="text-secondary-text-black text-xs font-medium">Joined {{
                                                    (item.created_at | date:'MMM yyyy') }}
                                                </p>
                                            </div>
                                        </div>
                                        <span class="block w-full h-px bg-secondary-button-black my-5"></span>
                                        <div class="grid grid-cols-3 gap-5">
                                            <div class="flex flex-col gap-2">
                                                <p class="text-black text-base font-medium !leading-3">{{
                                                    item.global_positions || '0.00' }}</p>
                                                <p class="text-xs font-medium text-secondary-text-black">Positions</p>
                                            </div>
                                            <div class="flex flex-col gap-2">
                                                <p [ngClass]="(item.global_pnl >= 0) ? 'text-primary-text-green' : 'text-primary-text-yellow'"
                                                    class="text-base font-medium !leading-3">
                                                    {{ (item.global_pnl >= 0 ? '+' : '-') }}${{ (item.global_pnl < 0 ?
                                                        -item.global_pnl : item.global_pnl) | number:'1.0-0' }} </p>
                                                        <p class="text-xs font-medium text-secondary-text-black">
                                                            Profit/loss</p>
                                            </div>
                                            <div class="flex flex-col gap-2">
                                                <p class="text-black text-base font-medium !leading-3">{{ '$' +
                                                    (item.global_volume | number:'1.0-0') }}</p>
                                                <p class="text-xs font-medium text-secondary-text-black">Volume</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-center justify-between gap-[30px] min-w-60 max-[767px]:min-w-0">
                                <p class="text-lg font-medium !leading-3" [ngClass]="{
                                        'text-primary-text-green': item.pnl >= 0,
                                        'text-primary-text-yellow': item.pnl < 0,
                                        'max-[767px]:hidden': activeProfitTab === 'volume'
                                    }">
                                    {{ (item.pnl >= 0 ? '+' : '-') }}${{ (item.pnl < 0 ? -item.pnl : item.pnl) |
                                        number:'1.2-2' }} </p>
                                        <p class="text-lg font-medium !leading-3" [ngClass]="{
                                                'text-black': activeProfitTab === 'volume',
                                                'text-secondary-text-black': activeProfitTab !== 'volume',
                                                'max-[767px]:hidden': activeProfitTab === 'profit'
                                            }">
                                            {{ '$' + (item.volume | number:'1.2-2') }}
                                        </p>
                            </div>
                        </div>
                        <span class="block w-full h-px bg-secondary-button-black my-2.5 mx-4"></span>
                    </div>

                    <!-- Logged-in User Row -->
                    <div *ngIf="userStats" [routerLink]="['/leaderboard-details']"
                        [queryParams]="{ user_id: userStats.user_id || userStats.id }"
                        class="mt-8 bg-gray-50 border-t-2 border-primary-text-green/20 p-5 rounded-2xl shadow-sm cursor-pointer hover:bg-gray-100 duration-200">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-4">
                                <span class="text-black text-lg font-bold min-w-[24px]">
                                    <ng-container *ngIf="userStats.rank && userStats.rank !== 0">#{{ userStats.rank
                                        }}</ng-container>
                                </span>
                                <div class="relative">
                                    <div class="flex items-center justify-center w-11 h-11 rounded-full bg-secondary-button-black text-black font-bold uppercase border-2 border-white shadow-sm"
                                        *ngIf="!userStats.profile_picture">
                                        {{ userStats.username?.charAt(0) }}
                                    </div>
                                    <img [src]="userStats.profile_picture" *ngIf="userStats.profile_picture"
                                        class="w-11 h-11 rounded-full border-2 border-white shadow-sm" />
                                    <div
                                        class="absolute -bottom-1 -right-1 bg-primary-text-green w-4 h-4 rounded-full border-2 border-white">
                                    </div>
                                </div>
                                <div class="flex flex-col">
                                    <p class="text-lg font-bold text-black leading-none">Me ({{
                                        shortenUsername(userStats.username) }})</p>
                                    <span class="text-xs text-secondary-text-black mt-1">
                                        {{ (userStats.rank && userStats.rank !== 0) ? 'Current Ranking' : 'Not Ranked'
                                        }}
                                    </span>
                                </div>
                            </div>
                            <div class="flex items-center justify-between gap-[30px] min-w-60 max-[767px]:min-w-0">
                                <p class="text-xl font-bold" [ngClass]="{
                                        'text-primary-text-green': userStats.pnl >= 0,
                                        'text-primary-text-yellow': userStats.pnl < 0,
                                        'max-[767px]:hidden': activeProfitTab === 'volume'
                                    }">
                                    <ng-container *ngIf="userStats.rank && userStats.rank !== 0; else emptyVal">
                                        {{ (userStats.pnl >= 0 ? '+' : '-') }}${{ (userStats.pnl < 0 ? -userStats.pnl :
                                            userStats.pnl) | number:'1.2-2' }} </ng-container>
                                </p>
                                <p class="text-xl font-bold" [ngClass]="{
                                        'text-black': activeProfitTab === 'volume',
                                        'text-secondary-text-black': activeProfitTab !== 'volume',
                                        'max-[767px]:hidden': activeProfitTab === 'profit'
                                    }">
                                    <ng-container *ngIf="userStats.rank && userStats.rank !== 0; else emptyVal">
                                        {{ '$' + (userStats.volume | number:'1.2-2') }}
                                    </ng-container>
                                </p>
                                <ng-template #emptyVal>--</ng-template>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="leaderboardData.length === 0"
                        class="py-20 text-center text-secondary-text-black text-lg">
                        No leaderboard data found.
                    </div>
                </div>

                <ng-template #loader>
                    <div class="py-20 flex justify-center items-center">
                        <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-black"></div>
                    </div>
                </ng-template>
              </div>
            </div>
        </div>

        <!-- Right Side Stats (Static for now as per original UI) -->
        <div class="wins-col col-span-12 lg:col-span-4 mt-10 lg:mt-0">
            <div class="sticky top-4">
                <div class="wins-panel p-5 border border-secondary-button-black rounded-[14px] relative">
                    <h2 class="text-black text-lg md:text-xl font-medium mb-6 max-[767px]:mt-3 max-[767px]:mb-3">Biggest wins this month</h2>

                    <!-- Below 992px this stacks sideways into a snapping slider; from 992px
                         up it stays the vertical list the sidebar has always shown -->
                    <div #winsTrack class="wins-track flex flex-col gap-5" (scroll)="onWinsScroll()">
                        <div *ngIf="topWinsLoading" class="wins-full py-8 flex justify-center items-center">
                            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-black"></div>
                        </div>

                        <!-- Real cards, then a second run of the same cards. Reaching the
                             copy of card 1 is an ordinary forward slide, and the jump back to
                             the real card 1 afterwards lands on an identical frame, so the
                             loop never shows a rewind or a gap. The copies only exist where
                             the list is a slider. -->
                        <ng-container *ngFor="let item of winsSlides; let i = index">
                            <ng-container *ngTemplateOutlet="winCard; context: { $implicit: item, index: i }"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="winsLoops">
                            <ng-container *ngFor="let item of winsSlides; let i = index">
                                <ng-container *ngTemplateOutlet="winCard; context: { $implicit: item, index: i }"></ng-container>
                            </ng-container>
                        </ng-container>

                        <div *ngIf="!topWinsLoading && topWinsData.length === 0"
                            class="wins-full py-6 text-center text-secondary-text-black text-base">
                            No top wins data found.
                        </div>
                    </div>

                    <ng-template #winCard let-item let-i="index">
                        <div class="wins-card flex flex-col">
                            <div class="flex items-center gap-4">
                                <div class="flex items-center gap-3.5">
                                    <span class="text-secondary-text-black text-lg font-medium">{{ i + 1 }}</span>
                                    <div class="flex items-center justify-center w-[30px] h-[30px] rounded-full bg-secondary-button-black text-black font-bold text-xs uppercase"
                                        *ngIf="!item.profile_picture">
                                        {{ item.username?.charAt(0) }}
                                    </div>
                                    <img [src]="item.profile_picture" *ngIf="item.profile_picture" alt="profile"
                                        class="w-[30px] h-[30px] rounded-full" />
                                </div>
                                <div class="w-[calc(100%-66px)] flex flex-col gap-2">
                                    <!-- Below 576px the two no longer fit side by side, so the
                                         market drops onto its own line under the name -->
                                    <div
                                        class="flex items-center gap-2.5 max-[576px]:flex-col max-[576px]:items-start max-[576px]:gap-1">
                                        <h3 class="text-black text-base font-medium">{{ shortenUsername(item.username)
                                            }}</h3>
                                        <span class="text-xl text-light-black-200 max-[576px]:hidden">|</span>
                                        <h4
                                            class="text-secondary-text-black text-base font-medium line-clamp-1 max-[576px]:w-full">
                                            {{ item.market_name || 'Top Win' }}</h4>
                                    </div>
                                    <div class="flex items-center gap-2.5">
                                        <p class="text-black text-base font-normal !leading-3">{{
                                            formatCurrency(item.winning_amount, '1.0-0') }}</p>
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                                viewBox="0 0 14 14" fill="none">
                                                <path d="M10.793 7L2.91797 7" stroke="black" stroke-opacity="0.5"
                                                    stroke-width="0.875" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M7.58398 3.5C7.58398 3.5 11.0839 6.07769 11.084 7C11.084 7.92237 7.58398 10.5 7.58398 10.5"
                                                    stroke="black" stroke-opacity="0.5" stroke-width="0.875"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                        <p class="text-base font-normal !leading-3"
                                            [ngClass]="item.profit >= 0 ? 'text-primary-text-green' : 'text-primary-text-yellow'">
                                            {{ item.profit >= 0 ? '+' : '-' }}{{ formatCurrency(item.profit >= 0 ?
                                            item.profit : -item.profit, '1.0-0') }}</p>
                                    </div>
                                </div>
                            </div>
                            <span *ngIf="i < 4"
                                class="wins-divider block w-full h-px bg-secondary-button-black my-5"></span>
                        </div>
                    </ng-template>

                    <!-- Slide indicators: only where the list is a slider -->
                    <div *ngIf="winsSlides.length > 1"
                        class="wins-dots min-[992px]:hidden flex items-center justify-center gap-2 mt-4">
                        <button *ngFor="let item of winsSlides; let i = index" type="button"
                            (click)="selectWinSlide(i)" [attr.aria-label]="'Go to win ' + (i + 1)"
                            [attr.aria-current]="i === activeWinDot"
                            class="h-2 rounded-full transition-all duration-300 cursor-pointer"
                            [ngClass]="i === activeWinDot ? 'w-5 bg-[#1CAE91]' : 'w-2 bg-secondary-button-black'"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>